export const pl_PL = {
  customer_type: "Typ klienta",
  manage_appointment_now: "Zarządzaj spotkaniem teraz",
  maintenance_page_title: "Calenso jest właśnie dla Ciebie ulepszane",
  maintenance_page_subtitle: "Calenso jest aktualizowane do najnowszej wersji. ",
  maintenance_page_button: "Do strony stanu",
  load_more: "Załaduj więcej",
  show_more: "Pokaż więcej",
  internal_label: "Wewnętrzny",
  check_availability_for_anyone: "Sprawdź dostępność dla każdego",
  store_not_found: "Nie znaleziono lokalizacji",
  appointment: "Spotkania",
  event: "Spotkania grupowe",
  resource: "Zasoby",
  morgen: "Poranek",
  vormittag: "Przedpołudnie",
  mittag: "Południe",
  nachmittag: "Popołudnie",
  abend: "Wieczór",
  nacht: "Noc",
  free: "Bezpłatne",
  hoursShort: "",
  minutesShort: "M",
  mondayLong: "Poniedziałek",
  day1: "PON",
  tuesdayLong: "Wtorek",
  day2: "WT",
  wednesdayLong: "Środa",
  day3: "ŚR",
  thursdayLong: "Czwartek",
  day4: "CZW",
  fridayLong: "Piątek",
  day5: "PT",
  saturdayLong: "Sobota",
  day6: "SOB",
  sundayLong: "Niedziela",
  day0: "ND",
  Januar: "Styczeń",
  Februar: "Luty",
  März: "Marzec",
  April: "Kwiecień",
  Mai: "Maj",
  Juni: "Czerwiec",
  Juli: "Lipiec",
  August: "Sierpień",
  September: "Wrzesień",
  Oktober: "Październik",
  November: "Listopad",
  Dezember: "Grudzień",
  "shortMonths": {
    "Januar": "Sty",
    "Februar": "Lut",
    "März": "Mar",
    "April": "Kwi",
    "Mai": "Maj",
    "Juni": "Cze",
    "Juli": "Lip",
    "August": "Sie",
    "September": "Wrz",
    "Oktober": "Paź",
    "November": "Lis",
    "Dezember": "Gru"
  },
  du: "Ty",
  sie: "Ty",
  havingFormDu: "Posiadać",
  havingFormSie: "Posiadać",
  yes: "Tak",
  no: "Nie",
  timezone: "Strefa czasowa",
  timezone_partner_hint: "Dostępne terminy są wyświetlane w strefie czasowej {{timezone}}.",
  confirm: {
    title: "Potwierdzić zamówienie",
    confirmationText: "Ty masz {{ cartLength }} terminy w koszyku. ",
    confirmationTextSie: "Twoje masz {{ cartLength }} terminy w koszyku. ",
    ok: "Książka",
    cancel: "Anulować"
  },
  internal: {
    search_customer: "Wyszukaj istniejącego klienta i wypełnij formularz",
    selectPlaceholder: "Wyszukaj klienta",
    customerDetails: "Szczegóły klienta",
    noCustomer: "Brak skonfigurowanych klientów",
    create_customer: "Utwórz klienta"
  },
  common: {
    report_bug: "Zgłoś błąd",
    subscription_error_title: "Bez abonamentu!",
    subscription_error_desc: "Przepraszamy, nie znaleziono subskrypcji. ",
    next: "Dalej",
    previous: "Wstecz",
    reset: "Zresetuj aplikację",
    resetSuccess: "Oprogramowanie do rezerwacji zostało pomyślnie zresetowane. ",
    loading: "Ładowanie ...",
    durationHour: "H",
    durationMinute: "M",
    clock: "H",
    disclaimer: "Ta usługa jest świadczona przez <a href='%BRAND_WEBSITE%' class='cal-link' target='_blank'>Calenso</a>.",
    book: "Zarezerwuj",
    choseBookType: "Co chciałbyś zarezerwować?",
    company: "Firma",
    prename: "Imię",
    lastname: "Nazwisko",
    email: "E-mail",
    phone: "Telefon",
    address: "Adres",
    createAccount: "Utwórz konto klienta (konto użytkownika ze wszystkimi rejestracjami)",
    noDateError: "Żądane spotkanie zostało zarezerwowane przez kogoś innego, wróć i wybierz nowe spotkanie.",
    devNotice: "Widżet rezerwacji jest połączony z systemem zaplecza DEV.",
    store_access_warning: 'Dostęp do pamięci przeglądarki jest ograniczony ze względu na ustawienia prywatności. Nie wszystkie funkcje widżetu rezerwacji mogą być dostępne.',
    save: "Zapisz",
    cancel: "Anuluj",
    additionalParticipantsUpTo: "Możesz dodać do {{ number }} gości",
    additionalParticipantsUpToOne: "Możesz dodać maksymalnie {{ number }} gościa",
    additionalGuest: "Dodatkowi uczestnicy",
    addAdditionalGuest: "Dodaj uczestników",
    entryModeIndividual: "Dodaj gości pojedynczo",
    entryModeAnonymous: "Podaj tylko liczbę",
    addGuestCount: "Podaj liczbę gości",
    addGuestCountHint: "Tylko liczba — imiona nie są wymagane",
    addParticipantHint: "Imię, nazwisko i dane kontaktowe",
    newParticipantTitle: "Dodaj uczestnika",
    editParticipantTitle: "Edytuj uczestnika",
    decrease: "Zmniejsz",
    increase: "Zwiększ",
    guestCountMaxWarning: "Dla tego terminu dozwolonych jest maksymalnie {{max}} gości.",
    guestCountMaxWarningOne: "Dla tego terminu dozwolony jest maksymalnie {{max}} gość.",
    anonymousGuestCount: "Ilu gości weźmie udział?",
    guestCountEditHelper: "Miejsca zostaną zarezerwowane wraz z rezerwacją — imiona nie są wymagane",
    guestCountHelper: "Zarezerwowane wraz z rezerwacją — imiona nie są wymagane",
    additionalGuestCartLabel: "{{ number }} miejsce dla gościa",
    additionalGuestsCartLabel: "{{ number }} miejsca dla gości",
    widget_disabled: "Rezerwacja jest obecnie niedostępna",
    widget_disabled_description: "Rezerwacja online u tego usługodawcy jest obecnie niedostępna. Prosimy o bezpośredni kontakt z usługodawcą w celu umówienia wizyty.",
    booking_unavailable: 'Rezerwacja jest obecnie niedostępna',
    booking_unavailable_description: 'Rezerwacja online u tego usługodawcy jest obecnie niedostępna. Prosimy o bezpośredni kontakt z usługodawcą w celu umówienia wizyty.',
    no_workers_widget_disabled_description: "Obecnie nie można zarezerwować żadnych spotkań, ponieważ żaden zasób nie jest włączony.",
    workers_not_available: "Nie znaleziono usługi, którą można zarezerwować",
    workers_not_available_description: "Nie zarejestrowano żadnej usługi, którą można zarezerwować. ",
    price_from_label: "z",
    close: "Zamknij",
    configuration_error: "Błąd konfiguracji",
    resource_is_not_bookable: "Wybranego zasobu nie można zarezerwować.",
    verification_token_missing: "Widżet rezerwacji jest używany w trybie wewnętrznym i dlatego wymaga tokena weryfikacyjnego. ",
    invalid_verification_code: "Dostęp do widżetu w trybie wewnętrznym wymaga ważnego tokenu, upewnij się, że token jest ważny, i spróbuj ponownie.",
    internal_appointment_booking_widget_disabled: "Usługa widgetu wewnętrznego została wyłączona przez partnera. Skontaktuj się z administratorem systemu, aby uzyskać więcej informacji.",
    external_appointment_booking_widget_disabled: "Usługa widgetu została wyłączona przez naszego partnera. Skontaktuj się z nimi, aby uzyskać więcej informacji.",
    external_event_booking_widget_disabled: "Usługa widgetu została wyłączona przez naszego partnera. Skontaktuj się z nimi, aby uzyskać więcej informacji.",
    external_pds_booking_widget_disabled: "Usługa rezerwacji predefiniowanych terminów została wyłączona przez naszego partnera. Skontaktuj się z nimi, aby uzyskać więcej informacji.",
    conference_invalid_link: "Wygląda na to, że podany link do konferencji jest nieprawidłowy. Proszę sprawdź link i spróbuj ponownie.",
    conference_expired_link: "Przykro nam, ale ten link do konferencji wygasł. Skontaktuj się z organizatorem w celu uzyskania dalszej pomocy.",
    conference_not_belonging: "Ups, wygląda na to, że ta konferencja jest powiązana z innym partnerem.",
    conference_booked: "Ups, wygląda na to, że ten link do konferencji został już użyty i zarezerwowany. Jeśli masz pytania lub potrzebujesz pomocy, śmiało skontaktuj się z organizatorami.",
    conference_invalid_configurations: "Konferencja jest niedostępna z powodu nieprawidłowych wewnętrznych konfiguracji. W celu uzyskania dalszej pomocy, skontaktuj się z organizatorem.",
    location: "Lokalizacja",
    empty_string_validation: "Same spacje nie są dozwolone.",
    invalid_password: "Wprowadź poprawne hasło.",
    send_otp: "Wyślij OTP",
    resend_otp: "Poproś ponownie",
    resend_otp_available_in: "Wyślij ponownie OTP dostępny w",
    didnt_receive_otp: "Nie otrzymałeś OTP?",
    ensure_you_have_access_to_your_email_to_receive_the_otp: "Upewnij się, że masz dostęp do swojego e-maila, aby otrzymać OTP.",
    ensure_you_have_access_to_your_mobile_to_receive_the_otp: "Upewnij się, że masz dostęp do swojego telefonu, aby otrzymać OTP.",
    otp_will_be_sent_to: "Wyślemy kod dostępu do użytku jednorazowego (OTP) na {{ recipient }}"
  },
  appointments: {
    step1: {
      distance_from_store: "{{ distance }} km stąd",
      search_store_postcode_helper_text: "Wpisz kod pocztowy, aby wyszukać najbliższą lokalizację",
      search_services_helper_text: "Wprowadź wyszukiwane hasło, aby wyszukać usługi",
      title: "Usługa",
      chooseStore: "Wybierz lokalizację",
      chooseService: "Wybierz usługę",
      nextButton: "Dalej",
      search_store_by_postcode_placeholder: "Wpisz kod pocztowy, aby wyszukać lokalizację",
      create_lead: "Okazja MH",
      expert_cap_button_label: "Przydziel do eksperta CAP",
      appointment_booking_not_available_for_zipcode: "Przepraszamy, rezerwacja terminu nie jest dostępna dla tego kodu pocztowego. "
    },
    step2: {
      title: "Pomoc",
      chooseEmployee: "Wybierz bezpłatny zasób",
      name: "Nazwa",
      function: "Funkcjonować",
      noSpecificWorker: "Ktoś",
      noSpecificFunction: "Wszystkie funkcje",
      exception: "Zdefiniuj wyjątek dla pracownika",
      nextButton: "Wybierz datę/godzinę"
    },
    step3: {
      title: "Data",
      chooseDate: "Wybierz preferowaną datę",
      morning: "Poranek",
      forenoon: "Przedpołudnie",
      noon: "Południe",
      afternoon: "Popołudnie",
      evening: "Wieczór",
      night: "Noc",
      infoMsg: "Pamiętaj, że istnieje możliwość wyboru wielu terminów. ",
      appointment: "Spotkanie",
      employee: "Pomoc",
      proposals: "Darmowe terminy",
      noFreeAppointments: "Niestety w tym dniu nie ma wolnych terminów!",
      nextButton: "Dalej",
      cartNotSupported: "Ten dostawca obsługuje tylko jedną rejestrację terminu na rezerwację.",
      cartSupported: "Ten dostawca obsługuje wiele rejestracji na rezerwację.",
      workerSelectLable: "Wybierz Doradcę Osobistego:",
      workerSelectLinkPrefix: "Nie znalazłeś spotkania z doradcą?",
      workerSelectShowAllLinkPostfix: "Pokaż wszystkich doradców",
      workerSelectHideAllLinkPostfix: "Ukryj wszystkich doradców",
      troubleshooting_mode_note_pre: "Brakuje terminu? Spróbuj ",
      troubleshooting_mode_link: "trybu rozwiązywania problemów",
      troubleshooting_mode_note_post: " i uzyskaj więcej informacji o niedostępnych terminach.",
      turn_off_troubleshooting_pre: "Wyłącz ",
      turn_off_troubleshooting_link: "tryb rozwiązywania problemów",
      turn_off_troubleshooting_post: ".",
      common_notes: "Wspólne notatki"
    },
    step4: {
      comment_helper_text: "Maksymalnie 2000 znaków",
      title: "Zakończ",
      summary: "Podsumowanie",
      company: "Firma",
      store: "Lokalizacja",
      employee: "Pomoc",
      bookedServices: "Praca",
      duration: "Czas trwania",
      price: "Cena",
      finalPrice: "Cena końcowa",
      total: "Suma",
      yourData: "Twoje dane",
      disclaimer: "Proszę podać swoje osobiste dane kontaktowe. ",
      prename: {
        label: "Imię",
        placeholder: "Imię",
        error: {
          minChars: "Imię wymaga co najmniej {{ requiredLength }} znaków.",
          required: "Wpisz imię."
        }
      },
      lastname: {
        label: "Nazwisko",
        placeholder: "Nazwisko",
        error: {
          minChars: "Nazwisko wymaga co najmniej {{ requiredLength }} znaków.",
          required: "Wpisz nazwisko."
        }
      },
      phone: {
        label: "Telefon komórkowy",
        placeholder: "4179xxxxxxx",
        error: {
          pattern: "Numer telefonu może zawierać tylko cyfry.",
          minChars: "Numer telefonu wymaga co najmniej {{ requiredLength }} cyfr.",
          required: "Wprowadź numer telefonu."
        }
      },
      eMail: {
        label: "E-mail",
        error: {
          pattern: "Proszę podać poprawny adres e-mail.",
          minChars: "Adres e-mail wymaga co najmniej {{ requiredLength }} znaków.",
          required: "Wpisz adres e-mail."
        }
      },
      message: {
        label: "Wiadomość",
        placeholder: ""
      },
      internal_comment: {
        label: "Komentarz wewnętrzny",
        placeholder: "Dodaj komentarze do użytku wewnętrznego",
        comment_helper_text: "Maksymalnie 5000 znaków."
      },
      company_name: {
        label: "Nazwa firmy",
        error: {
          minChars: "Too pole wymaga wprowadzenia min. {{ requiredLength }} znaków."
        }
      },
      customFields: {
        defaultOption: "Wybierz opcję",
        error: {
          maxChars: 'Too pole wymaga wprowadzenia maks. {{ requiredLength }} znaków.',
          minChars: "Too pole wymaga wprowadzenia min. {{ requiredLength }} znaków.",
          required: "Too pole jest obowiązkowe",
          questionisRequired: "{{ text }} jest obowiązkowe",
          checkboxisRequired: "To pole wyboru musi być zaznaczone, aby kontynuować."
        }
      },
      cart: {
        emptyCartWarning: "Obecnie w koszyku nie ma żadnych spotkań.",
        removeIcon: "Usuń spotkanie z koszyka.",
        waiting_list: "Lista oczekujących"
      },
      numberSelect: {
        increase: 'Zwiększ wartość',
        decrease: 'Zmniejsz wartość'
      },
      birthday: {
        label: 'Urodzinki',
        error: {
          invalid: 'Podaj poprawną datę urodzin',
          required: 'Podaj swoje urodzinki.'
        }
      }
    },
    finalpage: {
      successTitle: "Pomyślnie zarezerwowałeś spotkanie",
      successMessageDu: "Rezerwacja spotkania została pomyślnie przesłana.  <br> <br> Jeśli z jakiegokolwiek powodu nie możesz wziąć udziału w wydarzeniu, anuluj je, korzystając z linku do anulowania w wiadomości e-mail lub SMS.",
      successMessageSie: "Rezerwacja spotkania została pomyślnie przesłana.  <br> <br> Jeśli z jakiegokolwiek powodu nie możesz wziąć udziału w wydarzeniu, anuluj je, korzystając z linku do anulowania w wiadomości e-mail lub SMS.",
      errorTitle: "Wystąpił błąd.",
      errorMessage: "Nie udało się zarezerwować terminu. ",
      errorMessageDu: 'Przepraszamy, nie udało się zarezerwować spotkania. Spróbuj ponownie.',
      errorMessageSie: 'Przepraszamy, spotkanie nie mogło zostać zarezerwowane. Spróbuj ponownie.',
      bookNextAppointment: "Zarezerwuj dodatkowe spotkanie",
      bookAppointmentAgain: "Wróć"
    }
  },
  events: {
    list: "Lista",
    grid: "Siatka",
    noEvents: "Ten dostawca nie określił jeszcze żadnych wydarzeń.",
    hidden_events_message: "Wydarzenia tego partnera są ukryte. ",
    filter_result_null: "Nie ma wyników spełniających Twoje kryteria.",
    step1: {
      title: "Wydarzenia",
      moreInformation: "Więcej informacji",
      noFreeSlots: "Nie ma już wolnych terminów",
      noEvents: "Nie utworzono jeszcze żadnych wydarzeń.",
      showDescription: "Pokaż cały opis",
      hideDescription: "Ukryj opis",
      book: "Książka",
      noPlaceDefined: "Nie określono miejsca",
      store_filter: "Przechowuj filtr",
      category_filter: "Filtr kategorii",
      all_categories: "Wszystko"
    },
    step2: {
      title: "Data",
      slots: "Terminy",
      chooseDate: "Wybierz preferowaną datę",
      booked: "Zarezerwowane",
      capacity: "Dostępne",
      noFreeDates: "Nie ma bezpłatnych wydarzeń dla tego partnera",
      bookedOut: "To miejsce jest już zarezerwowane",
      cartNotSupported: "Ten dostawca obsługuje tylko jedno miejsce na rezerwację.",
      cartSupported: "Ten dostawca obsługuje wiele rejestracji na rezerwację.",
      alreadyBookedByUser: "To miejsce zostało już przez Ciebie zarezerwowane. ",
      waitinglist: "Lista oczekujących: {{ capacity }} bezpłatny",
      fully_booked: "W pełni zarezerwowane",
      regular_count_singular: "<b>1</b> wolne miejsce",
      regular_count_plural: "<b>{{ number }}</b> wolne miejsca",
      waiting_count_singular: "1 wolne miejsce na liście oczekujących",
      waiting_count_plural: "{{ number }} wolnych miejsc na liście oczekujących",
      free_seats: "Wolne miejsca",
      free_waiting_seats: "Wolne miejsca na liście oczekujących",
      multiday_group_appointment: "To jest wielodniowe spotkanie grupowe"
    },
    step3: {
      title: "Zakończ",
      summary: "Podsumowanie",
      company: "Firma",
      store: "Lokalizacja",
      employee: "Pomoc",
      bookedEvent: "Wydarzenie",
      date: "Data",
      time: "Czas",
      price: "Cena",
      finalPrice: "Cena końcowa",
      total: "Suma",
      yourData: "Twoje dane",
      disclaimer: "Proszę podać swoje dane kontaktowe. ",
      cart: {
        emptyCartWarning: "Obecnie w koszyku nie ma żadnych wydarzeń.",
        waiting_list: "Lista oczekujących"
      }
    },
    finalpage: {
      successTitle: "Rejestracja została pomyślnie przesłana.",
      successMessageDu: "Rejestracja na wydarzenie została pomyślnie przesłana.  <br> <br> Jeśli z jakiegokolwiek powodu nie możesz wziąć udziału w wydarzeniu, anuluj je, korzystając z linku do anulowania w wiadomości e-mail lub SMS.",
      successMessageSie: "Rejestracja na wydarzenie została pomyślnie przesłana.  <br> <br> Jeśli z jakiegokolwiek powodu nie możesz wziąć udziału w wydarzeniu, anuluj je, korzystając z linku do anulowania w wiadomości e-mail lub SMS.",
      errorTitle: "Wystąpił błąd.",
      errorMessage: "Wystąpił błąd podczas rejestracji. ",
      bookNextEvent: "Zarezerwuj dalszą rejestrację",
      bookEventAgain: "Wróć"
    }
  },
  resources: {
    noResources: "Ten dostawca nie określił jeszcze żadnych zasobów.",
    step1: {
      title: "Zasoby",
      chooseResource: "Wybierz zasoby"
    },
    step2: {
      title: "Data",
      startDate: "Data rozpoczęcia: ",
      endDate: "Data końcowa: ",
      startTime: "Wybierz godzinę rozpoczęcia",
      endTime: "Wybierz godzinę zakończenia",
      resetCalendar: "Zresetuj kalendarz",
      noFreeResources: "Nie znaleziono zasobów, które można zarezerwować dla zakresu dat",
      selectDate: "Wybierz datę lub zakres dat"
    },
    step3: {
      title: "Zakończ",
      summary: "Podsumowanie",
      company: "Firma",
      store: "Lokalizacja",
      employee: "Pomoc",
      bookedEvent: "Wydarzenie",
      date: "Data",
      time: "Czas",
      price: "Cena",
      finalPrice: "Cena końcowa",
      total: "Suma",
      yourData: "Twoje dane",
      disclaimer: "Proszę podać swoje dane kontaktowe. ",
      prename: {
        label: "Imię",
        placeholder: "Imię",
        error: {
          minChars: "Imię wymaga co najmniej {{{ requiredLength }} znaków.",
          required: "Proszę podać imię."
        }
      },
      lastname: {
        label: "Nazwisko",
        placeholder: "Nazwisko",
        error: {
          minChars: "Nazwisko wymaga co najmniej {{{ requiredLength }} znaków.",
          required: "Wpisz nazwisko."
        }
      },
      phone: {
        label: "Telefon komórkowy",
        placeholder: "4179xxxxxxx",
        error: {
          pattern: "Numer telefonu może zawierać tylko cyfry.",
          minChars: "Numer telefonu wymaga co najmniej {{ requiredLength }} znaków.",
          required: "Wprowadź numer telefonu."
        }
      },
      eMail: {
        label: "E-mail",
        error: {
          pattern: "Proszę wpisać aktualny adres e-mail.",
          minChars: "Adres e-mail wymaga co najmniej {{ requiredLength }} znaków.",
          required: "Wprowadź adres e-mail."
        }
      },
      message: {
        label: "Wiadomość",
        placeholder: ""
      },
      customFields: {
        defaultOption: "Wybierz dowolną opcję",
        error: {
          minChars: "Too pole wymaga wprowadzenia min. {{ requiredLength }} znaków.",
          required: "Too pole jest obowiązkowe"
        }
      },
      cart: {
        emptyCartWarning: "Obecnie w koszyku nie ma żadnych zasobów."
      },
      From: "Z",
      To: "Do"
    },
    finalpage: {
      successTitle: "Pomyślnie zarezerwowałeś zasoby",
      successMessageDU: "Jeśli zmienisz zdanie, anuluj przynajmniej rezerwację zasobów {{ leadTime }} godziny przed ich zarezerwowaniem.",
      successMessageSIE: "Jeśli zmienisz zdanie, anuluj przynajmniej rezerwację zasobów {{ leadTime }} godziny przed ich zarezerwowaniem.",
      errorTitle: "Wystąpił błąd.",
      errorMessage: "Nie można zarezerwować zasobu. ",
      bookNextEvent: "Zarezerwuj dodatkowe zasoby",
      bookEventAgain: "Wróć"
    }
  },
  customer: {
    prename: {
      label: "Imię",
      placeholder: "Imię",
      error: {
        minChars: "Imię wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Proszę podaj swoje imię."
      }
    },
    lastname: {
      label: "Nazwisko",
      placeholder: "Nazwisko",
      error: {
        minChars: "Nazwisko wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Proszę podać swoje nazwisko."
      }
    },
    phone: {
      label: "Numer telefonu",
      placeholder: "4179......",
      error: {
        pattern: "Numer telefonu może zawierać tylko cyfry.",
        minChars: "Numer telefonu wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Wprowadź swój numer telefonu.",
        invalid: "Wprowadź prawidłowy numer telefonu komórkowego."
      }
    },
    eMail: {
      label: "E-mail",
      error: {
        pattern: "Proszę wpisać aktualny adres e-mail.",
        minChars: "Adres e-mail wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Adres e-mail jest wymagany."
      }
    },
    street: {
      label: "Ulica / Nr.",
      placeholder: "Nazwa ulicy",
      error: {
        minChars: "Ulica wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Proszę podać nazwę ulicy."
      }
    },
    zip: {
      label: "Kod pocztowy",
      placeholder: "Kod pocztowy",
      error: {
        minChars: "Kod pocztowy wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Wprowadź kod pocztowy.",
        pattern: "Proszę wprowadzić poprawny kod pocztowy.",
      }
    },
    city: {
      label: "Miasto",
      placeholder: "Nazwa miasta",
      error: {
        minChars: "Miasto wymaga co najmniej {{ requiredLength }} znaków.",
        required: "Wpisz nazwę swojego miasta."
      }
    },
    message: {
      label: "Wiadomość",
      placeholder: ""
    },
    customFields: {
      defaultOption: "Wybierz opcję",
      error: {
        minChars: "Too pole wymaga wprowadzenia min. {{ requiredLength }} znaków.",
        required: "Too pole jest wymagane."
      }
    },
    captcha: {
      required: "Too pole jest wymagane.",
      invalid: "Proszę wprowadzić poprawną captcha.",
      valid: "Captcha została pomyślnie dopasowana.",
      placeholder: "Wpisz tekst pokazany powyżej"
    }
  },
  stripe: {
    stripe_title: "Zapłać za kolejną wizytę online",
    submit_payment: "Potwierdź płatność",
    stripe_label: "Karta kredytowa lub karta debetowa",
    online_payment_optional: "W tym kroku masz możliwość umówienia się na kolejną wizytę już teraz.",
    online_payment_mandatory: "Aby dokończyć rezerwację, uprzejmie prosimy o opłacenie kolejnej wizyty już teraz."
  },
  alert_messages: {
    select_day_in_calendar_msg: "Wybierz konkretny dzień w kalendarzu, aby otrzymać sugerowane możliwe daty.",
    no_events_in_month: "Niestety w wybranym miesiącu nie ma już wolnych terminów.",
    no_events: "Niestety to wydarzenie nie ma okien, które można zarezerwować w przyszłości.",
    waitinglist_enabled_message: "Niektóre przedziały czasowe są już w pełni zarezerwowane.",
    waitinglist_booking_message: "Dziękujemy! ",
    window_is_fully_booked: "To okno czasowe jest w pełni zarezerwowane (w tym lista oczekujących).",
    singular_waitinglist_is_available: "Ten przedział czasowy jest już zajęty, ale nadal jest <b>{{ number }}</b> wolne miejsce na liście oczekujących.",
    plural_waitinglist_is_available: "Ten przedział czasowy jest już zajęty, ale nadal są <b>{{ number }}</b> wolne miejsca na liście oczekujących.",
    no_bookable_dates_message: "Niestety nie ma więcej dni do rezerwacji w miesiącu {{ month }}.",
    no_slots_dates_message: "Niestety nie ma już wolnych terminów w danym miesiącu {{ month }}.",
    no_slots_dates_reached_message: "Niestety nie ma już wolnych terminów w danym miesiącu {{ month }}.",
    no_slots_years_reached_message: "Niestety, nie ma więcej dostępnych terminów w roku {{ year }}. Maksymalny okres rezerwacji został osiągnięty.",
    no_bookable_dates_reached_message: "Niestety w danym miesiącu nie ma już wolnych terminów {{ month }}.",
    xss_error_message: "Ten tekst zawiera nieobsługiwane tagi HTML.",
    slot_already_reserved_by_other_error: "W międzyczasie termin, który próbujesz zarezerwować, został już zajęty przez kogoś innego. Wybierz inny termin i spróbuj ponownie później.",
    failed_to_reserve_slot_error: "Coś poszło nie tak podczas rezerwacji terminu. Spróbuj ponownie później!",
    reserved_by_someone: "Zarezerwowane przez kogoś innego",
    next_step_error_customer_type: 'Wybierz typ klienta, aby kontynuować.',
    next_step_error_service: 'Wybierz usługę, aby kontynuować.',
    next_step_error_worker: 'Wybierz zasób, aby kontynuować.',
    next_step_error_meeting_type: 'Wybierz, gdzie ma się odbyć spotkanie, aby kontynuować.',
    next_step_error_date: 'Wybierz datę i okno czasowe, aby kontynuować.',
  },
  coupon_credit_card_info: {
    redeem_coupon_1: "Zrealizuj kupon",
    apply_coupon: "Zastosuj kupon",
    coupon: "Kupon",
    credit_or_debit_card: "karta kredytowa lub debetowa",
    invalid_coupon: "Nieważny kupon",
    applied_successfully: "Zastosowano pomyślnie",
    insufficient_balance_error: "Kupon nie ma wystarczającego salda do realizacji.",
    coupon_email_required_error: "Wymagany jest poprawny adres e-mail, aby go wykorzystać.",
    coupon_applied_remaining_balance: "Zastosowano pomyślnie. Pozostałe saldo po zastosowaniu kuponu wynosi {{ currency }} {{ amount }}."
  },
  tax_info: {
    taxes: "VAT",
    inclusive: "wł.",
    exclude: "bez",
    plus: "plus",
    net_total: "Razem",
    tax_line: "Plus {{percentage}}% VAT:",
    amount_incl_tax: "Kwota z VAT",
    tax_included_line: "VAT zawarty w cenie {{percentage}}%:",
    amount_excl_tax: "Kwota bez VAT"
  },
  new_alert_component: {
    x_day_ago: "x dzień temu",
    x_days_ago: "x dni temu",
    x_minute_ago: "x minutę temu",
    x_minutes_ago: "x minut temu",
    x_hour_ago: "x godzinę temu",
    x_hours_ago: "x godzin temu",
    x_second_ago: "x sekundę temu",
    x_seconds_ago: "x sekund temu",
    x_week_ago: "x tydzień temu",
    x_weeks_ago: "x tygodni temu",
    x_month_ago: "x miesiąc temu",
    x_months_ago: "x miesięcy temu",
    x_year_ago: "x rok temu",
    x_years_ago: "x lat temu"
  },
  adyen: {
    payment_method_label: 'Karta kredytowa lub debetowa',
    retry: 'Spróbuj ponownie',
    loading: 'Wczytywanie metod płatności…',
    hosted: {
      pay_button: 'Zapłać kartą',
      hint: 'Otworzy się bezpieczne okno płatności Adyen.',
      waiting: 'Dokończ płatność w oknie Adyen.',
      popup_blocked: 'Przeglądarka zablokowała okno płatności. Zezwól na wyskakujące okna dla tej strony i ponownie kliknij „Zapłać kartą”.',
      return_hint: 'Okno płatności zostało zamknięte lub zgubione?',
      complete_payment: 'Dokończ płatność',
      returned_elsewhere_title: 'Płatność otrzymana',
      returned_elsewhere: 'Wróć do karty, w której rozpoczęto rezerwację - tam zostanie ona dokończona. Nie płać tutaj ponownie. Jeśli ta karta została zamknięta, nic nie zostało zarezerwowane, a płatność zostanie automatycznie zwrócona w ciągu godziny.',
      start_new_booking: 'Rozpocznij nową rezerwację',
    },
    errors: {
      session_failed: 'Nie udało się rozpocząć płatności. Spróbuj ponownie.',
      refused: 'Płatność została odrzucona. Wybierz inną metodę płatności.',
      cancelled: 'Anulowałeś płatność.',
      pending: 'Płatność nie została jeszcze zakończona. Aby zapłacić ponownie, kliknij „Spróbuj ponownie” lub wybierz inną metodę płatności, jeśli jest dostępna.',
      unexpected: 'Podczas płatności wystąpił błąd. Spróbuj ponownie.',
      nothing_to_pay: 'Za tę rezerwację nie ma nic do zapłaty.',
      unavailable: 'Płatność kartą nie jest dostępna dla tej rezerwacji. Wybierz inną metodę płatności.',
      booking_refused: 'Nie udało się potwierdzić płatności kartą, więc nic nie zostało zarezerwowane. Spróbuj ponownie.',
      temporarily_unavailable: 'Płatność kartą jest chwilowo niedostępna. Spróbuj ponownie za chwilę.',
      context_changed: 'Twoja rezerwacja zmieniła się w trakcie płatności, dlatego nic nie zostało zarezerwowane. Dokonana już płatność zostanie automatycznie zwrócona. Sprawdź swój wybór i zapłać ponownie.',
      already_booked: 'Ta rezerwacja została już zrealizowana Twoją płatnością. Sprawdź e-mail z potwierdzeniem. Aby zarezerwować ponownie, kliknij „Spróbuj ponownie”.',
      expired: 'Sesja płatności wygasła. Spróbuj ponownie.',
      session_expired: 'Sesja płatności wygasła, więc nic nie zostało zarezerwowane. Ewentualnie pobrana kwota zostanie automatycznie zwrócona. Spróbuj ponownie.',
      resume_unavailable: 'Twoja przeglądarka nie pozwala wrócić do tej rezerwacji. Zapłać w bezpiecznym oknie Adyen i nie zamykaj tej strony.',
    },
  },
  summary_page_translations: {
    paypal_warning_msg: "Zanim rezerwacja będzie możliwa, należy wpłacić otwartą kwotę za pomocą systemu PayPal.",
    paypal: "PayPal",
    saferpay_payment_overlay: "Ten ekran ukryje się automatycznie po zakończeniu lub anulowaniu płatności.<br/>Jeśli ekran płatności zamknął się przypadkowo, dotknij przycisku zamykania, aby go ukryć i ponownie zainicjować płatność.",
    or: "Lub",
    browser: "Przeglądać",
    choose_file: "Wybierz plik",
    clear: "Jasne",
    meeting_type: "Gdzie ma się odbyć spotkanie?",
    email: "E-mail",
    sms: "SMS-y",
    both_sms_email: "E-mail i SMS",
    notification_type: "Typ powiadomienia",
    payment_title: "Zapłata",
    payment_subtitle: "Zdecyduj, jak chcesz płacić za usługi",
    payment_subtitle_sie: "Zdecyduj, jak chcesz płacić za usługi",
    summary_title: "Podsumowanie",
    summary_subtitle: "Sprawdź swoje zamówienie",
    summary_subtitle_sie: "Sprawdź swoje zamówienie",
    payment_type: "Typ płatności",
    creditcard: "Karta kredytowa",
    invoice: "Faktura",
    external_invoice: "Płatność na podstawie faktury",
    external_invoice_different_address: "Użyj innego adresu do faktury",
    invoice_address_title: "Adres do faktury",
    invoice_address_street_error: "Wprowadź ulicę i numer domu (np. Bahnhofstrasse 12).",
    lexoffice: "Faktura (LexOffice)",
    store: "Na miejscu",
    apply_coupon: "Chciałbym zastosować kod rabatowy",
    choose_payment_method: "Wybierz metodę płatności",
    other_payment_options: "Inne metody płatności",
    subtotal: "Suma częściowa",
    personal_form_title: "Dane osobiste",
    personal_form_subtitle: "Opowiedz nam coś o sobie",
    personal_form_subtitle_sie: "Opowiedz nam coś o sobie",
    inclusive: "włącznie",
    paymentMandatory: "Dostawca określił, że usługa musi być opłacona z góry. ",
    file_upload: "Udostępnianie pliku",
    file_upload_helper_text: "Można załączyć wiele plików",
    file_was_uploaded: "\"{{name}}\" został przesłany pomyślnie",
    max_file_size_5mb: "Przesłany plik jest za duży (dozwolone jest maksymalnie 5 MB).",
    malware_found: "Wystąpił problem podczas skanowania pliku pod kątem wirusów (Odmowa dostępu). Skontaktuj się z pomocą techniczną Calenso!",
    multiple_file_upload_helper_text: "Maksymalnie można przesłać 5 plików. ",
    single_file_upload_helper_text: "Można przesłać 1 plik. ",
    file_uploading: "Przesyłanie pliku jest nadal w toku. ",
    maximum_x_files: "Maksymalnie {{fileLength}} można przesyłać pliki.",
    document_invalid_file_type: "Nieprawidłowy rodzaj pliku. Dozwolone są tylko pliki PDF i Excel.",
    image_invalid_file_type: "Nieprawidłowy rodzaj pliku, proszę przesłać prawidłowy plik graficzny.",
    request_sms_code: "Kod zapytania",
    mobile_number_must_be_verified: "Numer musi zostać zweryfikowany.",
    verification_code: "Kod weryfikacyjny",
    sms_code_verification_failed_msg: "Wpisany kod niestety nie zgadza się z kodem, który wysłaliśmy SMS-em.",
    check: "Sprawdzać",
    phone_number_verified_successfully: "Numer został pomyślnie zweryfikowany.",
    resend_sms_helper_msg_1: "Nie otrzymałem kodu.",
    resend_sms_helper_msg_2: "Poproś o kod ponownie.",
    resend_sms_successfully: 'Kod SMS został wysłany pomyślnie',
    exceeded_sms_verification_limit_msg: "Ten numer przekroczył maksymalną liczbę kodów weryfikacyjnych. <a href=\"mailto:%BRAND_SUPPORT_EMAIL%\">%BRAND_SUPPORT_EMAIL%</a>).",
    salutation: "Pozdrowienie",
    mr: "Pan",
    ms: "Pani",
    other: "Inny",
    select_payment_method: "Proszę najpierw zapłacić otwartą kwotę za pomocą systemu PayPal, zanim będzie można złożyć rezerwację.",
    payment_method_required: 'Wybierz metodę płatności i dokończ płatność, aby złożyć rezerwację.',
    accept_data_policy: "Potwierdzam zapoznanie się z <a href=\"%BRAND_TERMS_URL%\" target=\"_blank\">OWU Calenso</a> oraz <a href=\"%BRAND_PRIVACY_URL%\" target=\"_blank\">polityką ochrony danych osobowych</a> oraz wyrażam zgodę na przetwarzanie moich danych w celu rezerwacji terminu.",
    saferpay: "Bezpieczna płatność",
    saferpay_pay: "Dotknij, aby zapłacić za pomocą Saferpay",
    payment_success_title: "Pomyślna płatność",
    payment_success_message: "Opłacono pomyślnie {{ paymentMethod }}. ",
    title: "Tytuł",
    country: "Kraj",
    title_aria_describedby: "Specjalny tytuł wspierający Dr., Dr. med., Prof. i Prof. Dr.",
    salutation_aria_describedby: "Forma grzecznościowa wspierająca Pana, Panią i inne",
    prename_aria_describedby: "Imię lub pierwsze imię",
    lastname_aria_describedby: "Nazwisko",
    notification_type_aria_describedby: "Aby zdefiniować w procesie rezerwacji, jak chcesz być powiadomiony o rezerwacji.",
    email_describedby: "E-mail",
    phoneNumber_aria_describedby: "Numer telefonu",
    smsPhoneCode_aria_describedby: "OTP do weryfikacji numeru telefonu",
    mobileNumber_aria_describedby: "Numer telefonu komórkowego",
    smsMobileCode_aria_describedby: "OTP do weryfikacji numeru telefonu komórkowego",
    street_aria_describedby: "Adres",
    zip_aria_describedby: "Kod pocztowy",
    city_aria_describedby: "Miasto",
    country_aria_describedby: "Kraj",
    comment_aria_describedby: "Dodatkowe uwagi, jeśli jakiekolwiek",
    internal_comment_aria_describedby: "Wewnętrzny komentarz (tylko do użytku wewnętrznego)",
    company_aria_describedby: "Nazwa firmy",
    captcha_aria_describedby: "Captcha",
    too_many_requests_exception: "Zbyt wiele próśb. Odetchnij i spróbuj za jakiś czas.",
    block_for_minute: "Zbyt wiele żądań. Poczekaj {{ time }} minutę przed wykonaniem dodatkowych żądań.",
    block_for_minutes: "Zbyt wiele żądań. Poczekaj {{ time }} minutę przed wykonaniem dodatkowych żądań.",
    block_for_second: "Zbyt wiele żądań. Poczekaj {{ time }} sekund przed wykonaniem dodatkowych żądań.",
    block_for_seconds: "Zbyt wiele żądań. Poczekaj {{ time }} sekund przed wykonaniem dodatkowych żądań.",
    sufficient_permissions_missing: "Nie masz wystarczających uprawnień, żeby to zrobić"
  },
  buttons: {
    yes_search: "Tak, szukaj.",
    remove: "Usuń"
  },
  add: "Dodaj",
  compact: {
    no_service: 'Aktualnie nie można umówić żadnych wizyt, ponieważ nie znaleziono pasującej usługi.',
    navigation: {
      date: 'Daty',
      date_slots: 'Daty i terminy',
      personal_info: 'Dane osobowe'
    }
  },
  reservation_timer: {
    reservation_expired_tooltip: 'Ten termin może nie być już dostępny. Wybierz nowy termin.',
    reservation_expired: 'Twój czas rezerwacji wygasł',
    reservation_time_remaining_tooltip: 'Ten termin jest zarezerwowany dla Ciebie. Dokończ rezerwację w pozostałym czasie, w przeciwnym razie może stać się dostępny dla innych użytkowników.',
    reservation_time_remaining: 'Czas rezerwacji: {{ time }} minut',
    reservation_expired_booking_blocked: 'Twoja rezerwacja wygasła. Wróć i wybierz nowy termin.',
    reservation_expired_payment_refunded: 'Twoja rezerwacja wygasła, więc nic nie zostało zarezerwowane. Płatność zostanie automatycznie zwrócona w ciągu godziny. Wróć i wybierz nowy termin.',
  },
  error_messages: {
    invalid_configuration: 'Nieprawidłowa konfiguracja, skontaktuj się z pomocą techniczną.',
    reached_max_limit: 'Prób było już za dużo. Spróbuj jeszcze raz!',
    something_went_wrong: 'Coś poszło nie tak, spróbuj ponownie później.',
    invalid_otp: 'Nieprawidłowy OTP'
  },
  payment_components: {
    refundNotice: 'Twoja płatność została przetworzona, ale rezerwacja nie mogła zostać zrealizowana. Pobrana kwota zostanie zwrócona w ciągu 24 godzin. Jeśli tak się nie stanie, skontaktuj się z pomocą techniczną i podaj identyfikator transakcji {{transactionId}}, abyśmy mogli szybciej pomóc.',
    bookingOutcomeUnknownNotice: 'Nie otrzymaliśmy odpowiedzi przed potwierdzeniem rezerwacji, więc mogła ona zostać zrealizowana lub nie. Zanim zapłacisz ponownie, sprawdź, czy w poczcie e-mail jest potwierdzenie rezerwacji. Jeśli nie dotrze w ciągu kilku minut, skontaktuj się z pomocą techniczną i podaj identyfikator transakcji {{transactionId}}.',
    bookingOutcomeUnknownError: 'Nie udało nam się potwierdzić rezerwacji. Zanim zapłacisz ponownie, sprawdź pocztę e-mail.',
    paymentSessionSpentError: 'Tej płatności nie można już użyć do nowej rezerwacji. Zanim zapłacisz ponownie, sprawdź pocztę e-mail.',
    paymentSessionSpentNotice: 'Tej płatności nie można już użyć do nowej rezerwacji. Sprawdź pocztę e-mail: jeśli jest w niej potwierdzenie rezerwacji, rezerwacja istnieje i nie wolno płacić ponownie. W przeciwnym razie rozpocznij nową płatność. Jeśli potrzebujesz pomocy, skontaktuj się z pomocą techniczną i podaj identyfikator transakcji {{transactionId}}.',
    paymentAlreadyBookedNotice: 'Rezerwacja została już zrealizowana tą płatnością. Sprawdź pocztę e-mail, aby znaleźć potwierdzenie rezerwacji, i nie płać ponownie. Jeśli potrzebujesz pomocy, skontaktuj się z pomocą techniczną i podaj identyfikator transakcji {{transactionId}}.',
    bookingStillCompletingError: 'Finalizujemy Twoją rezerwację. Zanim spróbujesz ponownie, sprawdź pocztę e-mail, aby znaleźć potwierdzenie rezerwacji.',
    bookingStillCompletingNotice: 'Finalizujemy Twoją rezerwację opłaconą tą płatnością. Zanim spróbujesz ponownie, sprawdź pocztę e-mail, aby znaleźć potwierdzenie rezerwacji, i nie płać ponownie. Jeśli w ciągu kilku minut nie otrzymasz potwierdzenia, skontaktuj się z pomocą techniczną i podaj identyfikator transakcji {{transactionId}}.',
    complete_payment_first: 'Przed rezerwacją dokończ płatność.',
    pay_again: 'Zapłać ponownie',
    form_incomplete: 'Proszę wypełnić wszystkie wymagane pola przed przejściem do płatności.',
    cancel_payment: 'Anuluj płatność',
    payment_in_progress: 'Płatność w toku – dokończ ją lub anuluj.',
    stripe_not_ready: 'Formularz płatności nie jest jeszcze gotowy. Poczekaj chwilę i spróbuj ponownie.',
    payment_processing_error: 'Nie udało się przetworzyć płatności. Spróbuj ponownie.',
  },
  pre_defined_slots: {
    select_slot_title: 'Wybierz termin',
    select_slot_description: 'Wybierz dostępny termin na swoją rezerwację.',
    list_view: 'Lista',
    calendar_view: 'Kalendarz',
    no_slots_available: 'Nie znaleziono dostępnych terminów.',
    no_services_available: 'Obecnie nie ma dostępnych usług do rezerwacji. Skontaktuj się z administratorem.',
    next_button: 'Dalej',
    previous_button: 'Wstecz',
    book_button: 'Zarezerwuj teraz',
    personal_data_title: 'Dane osobowe',
    personal_data_description: 'Wprowadź swoje dane osobowe.',
    summary_title: 'Podsumowanie',
    slot_details: 'Szczegóły terminu',
    personal_info: 'Dane osobowe',
    title_label: 'Tytuł',
    date_label: 'Data',
    time_label: 'Godzina',
    service_label: 'Usługa',
    location_label: 'Lokalizacja',
    name_label: 'Imię i nazwisko',
    email_label: 'E-mail',
    phone_label: 'Telefon',
    booking_error_title: 'Rezerwacja nie powiodła się',
    booking_failed: 'Nie udało się dokonać rezerwacji. Spróbuj ponownie.',
    slot_already_booked: 'Ten termin został już zarezerwowany przez inną osobę. Wybierz inny termin.',
    try_again_button: 'Spróbuj ponownie',
    select_service_title: 'Wybierz usługę',
    select_service_description: 'Wybierz usługę, aby zobaczyć dostępne terminy.',
    slots_available: 'terminów dostępnych',
    feature_unavailable_title: 'Funkcja niedostępna',
    feature_unavailable_message: 'Planowanie zasobów nie jest włączone dla tego partnera. Skontaktuj się z administratorem.',
  },
  pre_defined_slot: 'Predefiniowane terminy',
  tour_widget: {
    time_overview: 'Przegląd czasu',
    max_duration: 'Maks. {{hours}} godzin na trasę',
    total_duration: 'Całkowity czas',
    visit_time: 'Czas zwiedzania',
    travel_time: 'Czas podróży',
    travel_time_pill: '{{min}} min. podróży',
    selected_route: 'Wybrana trasa',
    no_selection: 'Nie wybrano jeszcze żadnego zakładu',
    book_tour: 'Zarezerwuj trasę',
    minutes_short: 'min.',
    error_exceeds_max: 'Trasa przekracza dozwolony czas — usuń przystanek.',
    error_feature_not_available: 'Ta funkcja nie jest uwzględniona w Twojej subskrypcji.',
    error_no_services_configured: 'Nie skonfigurowano jeszcze żadnych przystanków trasy. Skontaktuj się z organizatorem.',
    error_generic: 'Coś poszło nie tak. Spróbuj ponownie.',
    upcoming_absences_badge: 'Zaplanowana konserwacja',
    upcoming_absences_dialog_title: 'Nadchodząca konserwacja',
    upcoming_absences_dialog_close: 'Zamknij',
    upcoming_absences_all_day: 'Cały dzień',
  },
};
